import axios from "../../axios";

const api = {
  getConsumptionBasedIndirectEmissionsItems(params, accessToken) {
    const config = {
      params: params.queryParams,
      headers: { "Authorization": `Bearer ${accessToken}` }
    };
    return axios.get(`/supplier-questionnaires/consumption-based/${params.questionnaireId}/indirect-emissions/${params.type}`,
      config).then(({ data }) => data);
  },

  addConsumptionBasedIndirectEmissionsItem({ questionnaireId, data, type }, accessToken) {
    const headers = { headers: { "Authorization": `Bearer ${accessToken}` } };
    return axios.post(`/supplier-questionnaires/consumption-based/${questionnaireId}/indirect-emissions/${type}`, data, headers)
      .then(({ data }) => data);
  },

  updateConsumptionBasedIndirectEmissionsItem({ questionnaireId, recordId, data, type }, accessToken) {
    const headers = { headers: { "Authorization": `Bearer ${accessToken}` } };
    return axios.put(`/supplier-questionnaires/consumption-based/${questionnaireId}/indirect-emissions/${type}/${recordId}`, data, headers)
      .then(({ data }) => data);
  },

  deleteConsumptionBasedIndirectEmissionsItem({ questionnaireId, recordId, type }, accessToken) {
    const headers = { headers: { "Authorization": `Bearer ${accessToken}` } };
    return axios.delete(`/supplier-questionnaires/consumption-based/${questionnaireId}/indirect-emissions/${type}/${recordId}`, headers)
      .then(({ data }) => data);
  }
};

export default api;